import $ from 'jquery';

import './base.scss';
import loadImage from './load-image';

$(document).ready(() => {
  $('body').attr('ontouchstart', '');
});

$(window).load(() => {
  $('img').loadImage();
});



// WEBPACK FOOTER //
// ./src/assets/base/base.js